<template>
  <TemplateBase>
    <main class="relative z-0 col-span-full row-start-2" :class="{ 'xl:row-start-1': animalSuccesses.length > 0 }">
      <!-- Header -->
      <MoleculeHeaderOverview class="mb-8 mt-16 sm:mb-12 md:mb-8 lg:mt-20" :title="page.title" :subtitle="page.subtitle" :introduction="page.introduction" />
      <OrganismNavigationBreadcrumb class="container absolute z-30 top-0 2xl:-mt-16 mx-auto p-4 md:relative md:mb-16 md:px-8 md:py-0 lg:mb-20" :path="breadcrumbs" />

      <section class="container mx-auto px-6 sm:px-8">
        <ul class="grid gap-y-4 grid-cols-1 2xl:grid-cols-4 mb-6 sm:gap-x-8 sm:gap-y-10 sm:grid-cols-2 lg:grid-cols-3 lg:mb-16">
          <li v-for="(item, index) in animalSuccesses" :key="index" class="flex">
            <MoleculeCardOverview :url="item.url" :title="item.title" :subtitle="item.message" :image="item.images.length ? item.images[0] : undefined" :img-alt="item.title" />
          </li>
        </ul>
      </section>

      <!-- PAGINATION -->
      <section class="container relative mb-12 mx-auto">
        <OrganismPagination :count="totalHits" :limit="hitsPerPage" :page="pageNumber" @click="({ page }) => setPageNumber(page)" />
      </section>
    </main>
  </TemplateBase>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { routerQueryIsEqual } from '@/composables/setup-dynamic-url'
import { useAnimalSuccessOverviewStore } from '@/store/animal-success-overview'

interface Props {
  breadcrumbs?: Array<any>
  page?: {
    title: string
    subtitle: string
    introduction: string
  }
}

withDefaults(defineProps<Props>(), {
  breadcrumbs: () => [],
  page: () => ({
    title: '',
    subtitle: '',
    introduction: '',
  }),
})

const $route = useRoute()
const $router = useRouter()
const animalSuccessOverviewStore = useAnimalSuccessOverviewStore()

const animalSuccesses = computed(() => animalSuccessOverviewStore.animalSuccesses)
const hitsPerPage = computed(() => animalSuccessOverviewStore.hitsPerPage)
const pageNumber = computed(() => animalSuccessOverviewStore.pageNumber)
const totalHits = computed(() => animalSuccessOverviewStore.totalHits)
const urlParameters = computed(() => animalSuccessOverviewStore.urlParameters)

watch(urlParameters, (query) => {
  if (!routerQueryIsEqual($route.query, query)) {
    $router.push({ query })
  }
})

const setPageNumber = (page: number) => {
  animalSuccessOverviewStore.setPageNumber(page)
}
</script>
